import { UIHeading1, Image, UIText1, TColors } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import bigBanner from './big_banner.svg';
import smallBanner from './small_banner.svg';
import * as styles from './styles.css';

interface IMobileHeroBannerProps {
  className?: string;
  bigBannerClassName?: string;
  textColor?: TColors;
  showBigBanner?: boolean;
}

export const MobileHeroBanner: React.VFC<IMobileHeroBannerProps> = ({
  textColor = 'black_100',
  showBigBanner,
  bigBannerClassName,
  className,
}) => {
  return (
    <div className={cn(styles['container'], className, showBigBanner && bigBannerClassName)}>
      <div className={styles['top']}>
        <UIHeading1 as="h1" color={textColor}>
          Оцените квартиру бесплатно
        </UIHeading1>
        {!showBigBanner && (
          <div className={styles['image']}>
            <Image src={smallBanner} width={120} height={120} />
          </div>
        )}
      </div>
      <div className={styles['text']}>
        <UIText1 color={textColor}>Онлайн-проверка рыночной стоимости и арендной ставки</UIText1>
      </div>
      {showBigBanner && (
        <div className={styles['big_banner_wrapper']}>
          <div className={styles['big_banner']}>
            <Image src={bigBanner} width="100%" />
          </div>
        </div>
      )}
    </div>
  );
};
